import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/xmjrRoHvrxanNkG8pTnxnx/ChatGPT-Image-20-jun-2026_-22_07_30.webp';
export function FinalCTA() {
  return <section className="py-9 px-4 sm:px-6 bg-brand-green text-white text-center" data-id="element-45">
      <p className="text-xs font-bold text-brand-gold uppercase tracking-widest mb-3" data-id="element-46">
        ONE LAST CHANCE
      </p>

      <p className="text-sm sm:text-base font-medium mb-5 leading-snug max-w-2xl mx-auto text-white/90" data-id="element-47">
        Your dogs — and your clients — deserve more than improvised sessions.
        Stop spending hours planning every week. Stop second-guessing whether a
        protocol is right for the dog in front of you. Stop worrying about
        whether you're providing enough progression, enough structure, and
        enough professional value to justify your rates and grow your
        reputation.
        <span className="font-bold text-white block mt-3" data-id="element-48">
          Give every dog you work with the safe, structured, and science-backed
          training experience they deserve. Give every client the professional,
          results-driven service that turns them into loyal advocates for your
          work. Give yourself the system you should have had from Day One.
        </span>
      </p>

      <div className="bg-white/10 border border-brand-gold/40 rounded-lg p-4 mb-5 shadow-md max-w-sm mx-auto" data-id="element-49">
        <p className="text-xs sm:text-sm font-bold text-brand-gold mb-1 uppercase tracking-wide" data-id="element-50">
          🐾 DOG TRAINER PRO™ — 6-in-1 Complete Box Set + 5 Premium Bonuses
        </p>
        <p className="text-base line-through text-white/60 mb-0.5" data-id="element-51">$97 USD</p>
        <p className="text-3xl font-heading font-black text-white leading-none" data-id="element-52">
          Only: $27 USD
        </p>
      </div>

      <a href="#pricing" className="block cursor-pointer mb-5" data-id="element-53">
        <img src={PRODUCT_IMG} alt="Dog Trainer Pro 6-in-1 Complete Box Set" className="w-full max-w-[240px] mx-auto object-contain drop-shadow-2xl rounded-lg" data-id="element-54" />
      </a>

      <div className="mb-4 max-w-md mx-auto" data-id="element-55">
        <CTAButton data-id="element-56">🚀 YES, I WANT MY DOG TRAINER PRO™ PACK</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-1.5 sm:gap-5 text-[10px] sm:text-xs font-bold text-white/80" data-id="element-57">
        <div className="flex items-center gap-1.5" data-id="element-58">
          <Zap className="w-4 h-4 text-brand-orange" data-id="element-59" />
          <span data-id="element-60">Immediate Access — Delivered by Email</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-61">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-62" />
          <span data-id="element-63">4.9/5 — Verified Professional Reviews</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-64">
          <Shield className="w-4 h-4 text-brand-gold" data-id="element-65" />
          <span data-id="element-66">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}